import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[stopPropagationDeep]'
})
export class StopPropagationDeepDirective {
  constructor(private el: ElementRef) {}

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    event.stopPropagation();
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: Event) {
    event.stopPropagation();
  }

  @HostListener('mouseup', ['$event'])
  onMouseUp(event: Event) {
    event.stopPropagation();
  }

  @HostListener('focus', ['$event'])
  onFocus(event: Event) {
    event.stopPropagation();
  }



}
